import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AuthorizeAlert from './AuthorizeAlert';
import AuthorizeInfo from './AuthorizeInfo';
import Tracker from '../utils/usageTracker';
import { LISTING_STATUS } from '../data/models/ApplicationAuthorization';
import { useSelector } from 'react-redux';
import { getHasIntegrationsManagementWrite } from '../selectors/ScopeSelectors';
import { isOnlyRequestingOAuthScope } from '../utils/urls';
import { getApplicationAuthorizationData, getIsRequestingNewScopes } from '../selectors/AppSelectors';
import { EVENTS } from '../constants/Events';
import { MaxWidthContainer } from './MaxWidthContainer';
import { getDomainVerificationStatus, getListingStatus } from '../utils/appUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AuthorizeBody = ({
  authorizationData,
  authorizationDataStatus,
  isInternallyDeveloped,
  account,
  fullAppDetails
}) => {
  var _fullAppDetails$provi, _fullAppDetails$provi2;
  const hasIntegrationsManagementWrite = useSelector(getHasIntegrationsManagementWrite);
  const app = useSelector(getApplicationAuthorizationData);
  const location = useLocation();
  const cannotInstall = !hasIntegrationsManagementWrite && !isOnlyRequestingOAuthScope(location.search);
  const isRequestingNewScopes = useSelector(getIsRequestingNewScopes);
  const listingStatus = getListingStatus(fullAppDetails === null || fullAppDetails === void 0 ? void 0 : fullAppDetails.listingInfo);
  const domainStatus = getDomainVerificationStatus(fullAppDetails === null || fullAppDetails === void 0 ? void 0 : fullAppDetails.providerInfo);
  const providerDomain = fullAppDetails !== null && fullAppDetails !== void 0 && (_fullAppDetails$provi = fullAppDetails.providerInfo) !== null && _fullAppDetails$provi !== void 0 && _fullAppDetails$provi.isVerified ? (_fullAppDetails$provi2 = fullAppDetails.providerInfo.domain) !== null && _fullAppDetails$provi2 !== void 0 ? _fullAppDetails$provi2 : null : null;
  useEffect(() => {
    if (app && !app.authorized) {
      Tracker.track(EVENTS.AUTHORIZE_VIEW, {
        applicationId: app.appId,
        applicationName: app.name,
        domainVerificationStatus: domainStatus,
        listingStatus,
        scopeGroupCount: app.scopeGroups.length,
        scopeGroups: app.scopeGroups.map(sg => sg.name),
        hasInstallPermission: !cannotInstall,
        redirected: false,
        clientId: app.clientId,
        isRequestingNewScopes: !!isRequestingNewScopes
      });
    }
  }, [app, cannotInstall, isRequestingNewScopes, domainStatus, listingStatus]);
  return /*#__PURE__*/_jsxs(MaxWidthContainer, {
    children: [(listingStatus === LISTING_STATUS.UNLISTED && !isInternallyDeveloped || cannotInstall) && /*#__PURE__*/_jsx(AuthorizeAlert, {
      domainStatus: domainStatus,
      cannotInstall: cannotInstall,
      account: account
    }), /*#__PURE__*/_jsx(AuthorizeInfo, {
      appId: authorizationData.appId,
      authorizationData: authorizationData,
      authorizeStatus: authorizationDataStatus,
      listingStatus: listingStatus,
      providerName: authorizationData.name,
      providerDomain: providerDomain
    })]
  });
};
export default AuthorizeBody;